import { render, staticRenderFns } from "./Mechanical.vue?vue&type=template&id=913b388c&scoped=true"
import script from "./Mechanical.vue?vue&type=script&lang=js"
export * from "./Mechanical.vue?vue&type=script&lang=js"
import style0 from "./Mechanical.vue?vue&type=style&index=0&id=913b388c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913b388c",
  null
  
)

export default component.exports